import React from 'react';
import InventoryMeds from "../../InventoryMeds/InventoryMeds";
// import InventoryMedsDistributor from '../../InventoryMeds/InventoryMedsDistributors';
import InventoryMedsWards from '../../InventoryMeds/InventoryMedsWards';

const Inventory = ({ role }) => {

  let inventoryContent;
  if (role === 'distributor') {
    inventoryContent =  <InventoryMeds role={role}/>;
  } else if (role === 'pharmacist') {
    inventoryContent =<InventoryMeds role={role} />;
  }else if(role === 'ward'){
    inventoryContent = <InventoryMedsWards/>;
  } 
  else {
    inventoryContent = null;
  }

  return( 
  <>
  {inventoryContent}
    </>)
};

export default Inventory;
